import { useMemo } from 'react';
import { getDatePickerRestrictions, type DatePickerRestrictions } from './customDatePicker.utils';

export const useDatePickerRestrictions = (dateRestrictions?: DatePickerRestrictions) => {
  const relationDays = dateRestrictions?.userRelationDays ?? null;
  const relationVacationDays = dateRestrictions?.userRelationVacationDays ?? null;

  return useMemo(
    () =>
      getDatePickerRestrictions({
        userRelationDays: relationDays,
        userRelationVacationDays: relationVacationDays,
      }),
    [relationDays, relationVacationDays]
  );
};
